export const footerData = {
  name: "La Conciergerie",
  tagline: "/images/logo/logo-svg.svg",
  info: [
    {
      // icon: "/images/footer/email-arrow.svg",
      link: "contact@lesclesconciergerie.fr",
      href: "https://",
    },
  ],
  // links: [
  //   { name: "Home", href: "/" },
  //   { name: "About", href: "/about" },
  //   { name: "Services", href: "/#services" },
  //   { name: "Work", href: "/projects" },
  //   { name: "Terms", href: "/terms-and-conditions" },
  //   { name: "Privacy Policy", href: "/privacy-policy" },
  //   { name: "Error 404", href: "/not-found" },
  // ],
  socialLinks: [
    { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61584287111705" },
    { name: "Instagram", href: "https://www.instagram.com/lesclesconciergerie/" },
    { name: "Linkedin", href: "https://www.linkedin.com/company/110106865/admin/dashboard/" },
    { name: "Tiktok", href: "https://www.tiktok.com/@lesclesconciergerie?lang=fr"}
  ],
  copyright: "© La Conciergerie copyright 2025",
};
